import React from "react";
import ContactBanner from './contact_banner/ContactBanner';
import ContactForm from './contact_form/ContactForm'

export default function Contact() {
  return (
  <section className="contact-us">
    <ContactBanner/>
    <ContactForm/>
  </section>
  );
}
